<template>
  <div id="partners">
    <div  class="pj-page-title">
      {{name}}
      <div data-v-7eb0edae="" class="line">
        <em data-v-7eb0edae=""></em>
      </div>
    </div>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>

import {reContent, imgError} from '@/assets/utility.js'

export default {
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      content: '',
      name: '',
      text:{
        getJoin: '加入我们',
        getPartners:'合作伙伴',
        getLaw:'法律声明及隐私政策',
      }
    }
  },
  mounted() {
    this.name = this.text[this.$route.params.aid]
    this.getData()
  },
  methods: {
    imgError(pUrl) {
      imgError(pUrl)
    },
    getData() {
      this.$axios.post(`about/${this.$route.params.aid}`).then((res)=>{
        if (res) {
          this.content= reContent(res.content)
        }
      })
    }
  },
  watch: {
    $route: {
          handler() {
              this.name = this.text[this.$route.params.aid]
              this.getData()
        },
        deep: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.pj-page-title {
    margin-bottom: 30px;
    font-size: 22px;
    color: #009740;
    padding: rem(30) rem(225);
    .line {
      margin-top: 8px;
      width: 80px;
      height: 3px;
      background-color: #ccc;
       em {
            display: block;
            width: 40px;
            height: 3px;
            background-color: #2e7d32;
        }
    }
}
 @media only screen and (min-width: 768px) {
    #partners .content {
      padding: rem(50) rem(225);
    }
  }
  @media only screen and (max-width: 768px) {
    #partners .content {
      padding: .575rem;
    }
  }
</style>
